import styled from 'styled-components'
import { SkeletonElement } from '@notino/react-styleguide'
import { multiLineClamp, NotinoLabelRegular400 } from '../../../../styles/helpers'

export const EmployeesContainer = styled.div``

export const EmployeeContainer = styled.div`
	min-width: 120px;
	max-width: 160px;
	min-height: 160px;
	padding: 16px 10px 0 10px;
	text-align: center;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
`

export const ScrollableContent = styled.div`
	overflow-x: auto;
	display: flex;
`

export const EmployeeImageContainer = styled.div`
	width: 80px;
	height: 80px;

	img {
		display: block;
		aspect-ratio: 1;
		object-fit: contain;
		flex-shrink: 0;
		border-radius: 50%;
	}
`

export const EmployeeName = styled.span`
	${NotinoLabelRegular400};
	${multiLineClamp(2)};
	text-align: center;
`

export const SkeletonAvatarElement = styled(SkeletonElement)`
	border-radius: 50%;
	width: 80px;
	height: 80px;
`
